const regionsTurkey = [
  {
    id: '19',
    name: 'Аланья',
    country: '4',
  },
  {
    id: '20',
    name: 'Анталья',
    country: '4',
  },
  {
    id: '21',
    name: 'Белек',
    country: '4',
  },
  {
    id: '24',
    name: 'Бодрум',
    country: '4',
  },
  {
    id: '669',
    name: 'Болу',
    country: '4',
  },
  {
    id: '268',
    name: 'Бурса',
    country: '4',
  },
  {
    id: '25',
    name: 'Даламан',
    country: '4',
  },
  {
    id: '155',
    name: 'Дидим',
    country: '4',
  },
  {
    id: '306',
    name: 'Измир',
    country: '4',
  },
  {
    id: '586',
    name: 'Кайсери',
    country: '4',
  },
  {
    id: '599',
    name: 'Каппадокия',
    country: '4',
  },
  {
    id: '22',
    name: 'Кемер',
    country: '4',
  },
  {
    id: '154',
    name: 'Кушадасы',
    country: '4',
  },
  {
    id: '26',
    name: 'Мармарис',
    country: '4',
  },
  {
    id: '667',
    name: 'Сарыкамыш',
    country: '4',
  },
  {
    id: '23',
    name: 'Сиде',
    country: '4',
  },
  {
    id: '277',
    name: 'Стамбул',
    country: '4',
  },
  {
    id: '27',
    name: 'Фетхие',
    country: '4',
  },
  {
    id: '156',
    name: 'Чешме',
    country: '4',
  },
  {
    id: '278',
    name: 'Эрзурум',
    country: '4',
  },
];

function filterRegions(regions) {
  const grandRegions = [
    {
      id: '19,20,21,22,23',
      group: 'Анталийское побережье',
      country: '4',
    },
    {
      id: '24,155',
      group: 'Бодрум',
      country: '4',
    },
    {
      id: '26,25,27',
      group: 'Мармарис',
      country: '4',
    },
  ];

  grandRegions.forEach((region) => {
    region.children = [];
    const ids = region.id.split(',').map((id) => id.trim());
    ids.forEach((id) => {
      const childRegion = regions.find((r) => r.id === id);
      if (childRegion) {
        region.children.push(childRegion);
      }
    });
  });

  const remainingRegions = regions.filter(
    (region) => !grandRegions.some((r) => r.children.includes(region))
  );

  return [...grandRegions, ...remainingRegions];
}

const filteredRegionsTurkey = filterRegions(regionsTurkey);

export default filteredRegionsTurkey;
